import AllCampaignsPage from "@/pages/companyDashboard/AllCampaignsPage";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/campaigns/$status")({
  component: AllCampaignsPage,
  params: {
    parse: ({agencyId, status}) => ({
      agencyId: Number(agencyId),
      status: z.enum(["active", "complete", "paused", "planned", "open"]).parse(status),
    }),
    stringify: ({agencyId, status}) => ({
      agencyId: String(agencyId),
      status,
    }),
  },
});
